import React, { useEffect } from 'react'
import Button from '../../../../../Button'

const TabularButton = ({
  isActiveTabular = false,
  setIsActiveTabular,
  gridApi,
  t
}) => {
  useEffect(() => {
    if (gridApi) {
      const cState = gridApi.gridCore.columnApi.getColumnState()
      gridApi.gridCore.columnApi.resetColumnState()

      if (isActiveTabular) {
        gridApi.gridCore.gridOptions.groupDefaultExpanded = 5
        gridApi.gridCore.gridOptions.groupHideOpenParents = true
      } else {
        gridApi.gridCore.gridOptions.groupDefaultExpanded = 0
        gridApi.gridCore.gridOptions.groupHideOpenParents = false
      }

      gridApi.gridCore.columnApi.setColumnState(cState)
    }
  }, [isActiveTabular])

  return (
    <Button
      className='tabular-active-filter'
      kind='primary'
      size='default'
      onClick={() => {
        setIsActiveTabular(!isActiveTabular)
      }}
      type='button'
    >
      {isActiveTabular
        ? t('TableActions.TabularButton.DISABLE_TABULAR')
        : t('TableActions.TabularButton.ENABLE_TABULAR')}
    </Button>
  )
}

export default TabularButton
